import { render, staticRenderFns } from "./SearchV2.vue?vue&type=template&id=0db94e00&scoped=true"
import script from "./SearchV2.vue?vue&type=script&lang=js"
export * from "./SearchV2.vue?vue&type=script&lang=js"
import style0 from "./SearchV2.vue?vue&type=style&index=0&id=0db94e00&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db94e00",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0db94e00')) {
      api.createRecord('0db94e00', component.options)
    } else {
      api.reload('0db94e00', component.options)
    }
    module.hot.accept("./SearchV2.vue?vue&type=template&id=0db94e00&scoped=true", function () {
      api.rerender('0db94e00', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/search/SearchV2.vue"
export default component.exports